import ModalTemplate from "../../../components/ModalTemplate/ModalTemplate";
import Button from "../../../components/Button/Button";
import React, {useEffect, useState} from "react";
import "./EditModal.scss"
import InputModal from "./InputModal";
import AreaModal from "./AreaModal";
import TextModal from "./TextModal";
import {editIcon} from "../../../components/Icon/Icon";

const EditModal = ({item, radioGroups, setRadioGroups, onClose, onConfirm, onDelete, error, setError}) => {
    const [localSettings, setLocalSettings] = useState({});
    const [modalRadioGroups, setModalRadioGroups] = useState(radioGroups);

    useEffect(() => {
        setLocalSettings(item.settings);
    }, []);

    const handleChange = (field, value) => {
        setLocalSettings(prev => ({...prev, [field]: value}));
    }

    const handleSave = () => {
        if (item.type === "input" && (!localSettings.title || localSettings.title.trim() === "")) {
            setError("Title is required");
            return;
        } else if (localSettings.inputType === "select" && (!localSettings.hasOwnProperty("options") || localSettings.options.length === 0)) {
            setError("Options are required");
            return;
        } else if (localSettings.inputType === "radio" && (!localSettings.hasOwnProperty("selectedRadioGroup") || Object.entries(localSettings.selectedRadioGroup).length === 0)) {
            setError("Group name is required");
            return;
        }

        setError("");

        if (item.type === "input" || item.type === "text")
            localSettings.new = false;

        setRadioGroups(modalRadioGroups);

        onConfirm(item.id, localSettings);
    }

    const handleCancel = () => {
        if (item.settings.new) onDelete(item);
        setError("");
        onClose();
    }

    const footerActions = (
        <>
            <Button onClick={() => onDelete(item)} variant="delete">Delete</Button>
            <Button onClick={handleSave} variant="primary">Save</Button>
            <Button onClick={handleCancel} variant="secondary">Cancel</Button>
        </>
    )

    const modalTitle = () => {
        switch (item.type) {
            case "input":
                return "Edit input field";
            case "area":
                return "Edit area field";
            case "text":
                return "Edit text field";
        }
    }

    return (
        <ModalTemplate
            onClose={onClose}
            icon={editIcon}
            title={modalTitle()}
            footerActions={footerActions}
        >
            <div className="edit-modal">
                {item.type === "input" &&
                    <InputModal
                        handleChange={handleChange}
                        localSettings={localSettings}
                        modalRadioGroups={modalRadioGroups}
                        setModalRadioGroups={setModalRadioGroups}
                        error={error}
                    />
                }
                {item.type === "area" &&
                    <AreaModal
                        handleChange={handleChange}
                        localSettings={localSettings}
                        error={error}
                    />
                }
                {item.type === "text" &&
                    <TextModal
                        handleChange={handleChange}
                        localSettings={localSettings}
                    />
                }
            </div>
        </ModalTemplate>
    )
}

export default EditModal;